(function() {
/*
 * Video Playback Events
 */

    /*
     * Video Playback Started
     *
     * @listens videoPlaybackStarted
     * @fires dataLayer#Video Playback Started
     */
    window.addEventListener('videoPlaybackStarted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Started',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Playback Paused
     *
     * @listens videoPlaybackPaused
     * @fires dataLayer#Video Playback Paused
     */
    window.addEventListener('videoPlaybackPaused', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Paused',
                'properties': ev.detail
            });
        }
    });
    
    /*
     * Video Playback Seek Started
     *
     * @listens videoPlaybackSeekStarted
     * @fires dataLayer#Video Playback Seek Started
     */
    window.addEventListener('videoPlaybackSeekStarted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Seek Started',
                'properties': ev.detail
            });
        }
    });
    
    /*
     * Video Playback Seek Completed
     *
     * @listens videoPlaybackSeekCompleted
     * @fires dataLayer#Video Playback Seek Completed
     */
    window.addEventListener('videoPlaybackSeekCompleted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Seek Completed',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Playback Muted
     *
     * @listens videoPlaybackMuted
     * @fires dataLayer#Video Playback Muted
     */
    window.addEventListener('videoPlaybackMuted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Muted',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Playback Unmuted
     *
     * @listens videoPlaybackUnmuted
     * @fires dataLayer#Video Playback Unmuted
     */
    window.addEventListener('videoPlaybackUnmuted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Unmuted',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Playback Resumed
     *
     * @listens videoPlaybackResumed
     * @fires dataLayer#Video Playback Resumed
     */
    window.addEventListener('videoPlaybackResumed', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Resumed',
                'properties': ev.detail
            });
        }
    });
    
    /*
     * Video Playback Completed
     *
     * @listens videoPlaybackCompleted
     * @fires dataLayer#Video Playback Completed
     */
    window.addEventListener('videoPlaybackCompleted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Completed',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Playback Exited
     *
     * @listens videoPlaybackExited
     * @fires dataLayer#Video Playback Exited
     */
    window.addEventListener('videoPlaybackExited', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Playback Exited',
                'properties': ev.detail
            });
        }
    });

/*
 * Video Content Events
 */

    /*
     * Video Content Started
     *
     * @listens videoContentStarted
     * @fires dataLayer#Video Content Started
     */
    window.addEventListener('videoContentStarted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Content Started',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Content Playing
     *
     * @listens videoContentPlaying
     * @fires dataLayer#Video Content Playing
     */
    window.addEventListener('videoContentPlaying', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Content Playing',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Content Progress
     *
     * @listens videoContentProgress
     * @fires dataLayer#Video Content Progress
     */
    window.addEventListener('videoContentProgress', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Content Progress',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Content Completed
     *
     * @listens videoContentCompleted
     * @fires dataLayer#Video Content Completed
     */
    window.addEventListener('videoContentCompleted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Content Completed',
                'properties': ev.detail
            });
        }
    });

/*
 * Video Ad Events
 */

    /*
     * Video Ad Started
     *
     * @listens videoAdStarted
     * @fires dataLayer#Video Ad Started
     */
    window.addEventListener('videoAdStarted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Ad Started',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Ad Playing
     *
     * @listens videoAdPlaying
     * @fires dataLayer#Video Ad Playing
     */
    window.addEventListener('videoAdPlaying', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Ad Playing',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Ad Progress
     *
     * @listens videoAdProgress
     * @fires dataLayer#Video Ad Progress
     */
    window.addEventListener('videoAdProgress', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Ad Progress',
                'properties': ev.detail
            });
        }
    });

    /*
     * Video Ad Completed
     *
     * @listens videoAdCompleted
     * @fires dataLayer#Video Ad Completed
     */
    window.addEventListener('videoAdCompleted', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'Video Ad Completed',
                'properties': ev.detail
            });
        }
    });

})();